module.exports = __webpack_public_path__ + "static/media/image6.908fe762.jpeg";